import type { SVGProps } from 'react'

export const Check = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		{...props}
	>
		<path
			d="M1.125 6.375L4.125 9.375L10.875 2.625"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
